import { instance } from "../API/Axios";

export const AddSubscriberApi = async (req) =>{
    try{
        const response = await instance.post("AddSubscriber", req);

        return response.data;
    }
   catch(ex){
    throw ("Exception Occured "+ex)
   }
}

export const GetAllSubscibersApi = async (StatusId, Name, FilterBy) =>{
    try{
        const response = await instance.get("getAllSubscribers",{
            params:{
                StatusId : StatusId,
                Name : Name,
                FilterBy : FilterBy
            }
        });

        return response.data;
    }
   catch(ex){
    throw ("Exception Occured "+ex)
   }
}

export const ApproveOrRejectSubscriber = async (req) =>{
    try{
        const response = await instance.post("SubscriberApprovel", req);

        return response.data;
    }
   catch(ex){
    throw ("Exception Occured "+ex)
   }
}